import React, { useEffect, useMemo, useState } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import SearchIcon from "@mui/icons-material/Search";
import FromIcon from "../img/fromicon.png";
import ToIcon from "../img/toicon.png";
import DateIcon from "../img/dateicon.png";
import { Box, TextField, IconButton, Button, Autocomplete, } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import styleCss from "../Style/style";
import { NonAuthAxios } from "../Utilities/CommonAxios";
import { useFormik } from "formik";
import * as Yup from "yup"
import debounce from "lodash.debounce";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { encryptData } from "../Utilities/crypto";





const BusSearchBox = ({ fromDetails, toDetails, travelDates }) => {
  const navigate = useNavigate();
  const [fromtravelCities, setFromTravelCities] = useState([]);
  const [totravelCities, setToTravelCities] = useState([]);
  const [selectedFrom, setSelectedFrom] = useState("");
  const [selectedTo, setSelectedTo] = useState("");
  const from = fromDetails !== undefined ? JSON.parse(fromDetails) : "";
  const to = toDetails !== undefined ? JSON.parse(toDetails) : "";




  const fromFetchCities = useMemo(
    () =>
      debounce(async (city) => {
      
        if (!city || city.trim().length < 2) return;
        try {
          const apiResponse = await NonAuthAxios({
            url: "/city_non_token",
            method: "post",
            payload: { city_name: city },
         
          });

          if (apiResponse.status) {
            setFromTravelCities(apiResponse?.data);
         
          } else {
            setFromTravelCities([]);
          }
        } catch (err) {
          setFromTravelCities([]);
        }
      }, 300),
    []
  );



  const toFetchCities = useMemo(
    () =>
      debounce(async (city) => {
        if (!city || city.trim().length < 2) return;
        try {
          const apiResponse = await NonAuthAxios({
            url: "/city_non_token",
            method: "post",
            payload: { city_name: city },
          });

          if (apiResponse.status) {
            setToTravelCities(apiResponse?.data);
          } else {
            setToTravelCities([]);
          }
        } catch (err) {
          setToTravelCities([]);
        }
      }, 300),
    []
  );

  const travelFormik = useFormik({
    initialValues: {
      from: from ?? null,
      to: to ?? null,
      travelDate: travelDates ?? dayjs()
    },
    validationSchema: Yup.object({
      from: Yup.object()
        .required("From city required"),
      to: Yup.object()
        .required("to city required")
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, isValid) => {

      if (isValid) {
        navigate(`/bus-tickets/${encryptData(JSON.stringify(values?.from))}/${encryptData(JSON.stringify(values?.to))}/${dayjs(values.travelDate)}`)
      }
    }
  })


  const handleSwap = () => {
    const from = travelFormik.values.from;
    const to = travelFormik.values.to;
    travelFormik.setFieldValue("from", to);
    travelFormik.setFieldValue("to", from);
  };

  const handleClick = () => {
    const today = dayjs();
    travelFormik.setFieldValue('travelDate', today.add(1, "day"))
  }

  const handleTodaybutton = () => {

  }





  useEffect(() => {
    const fetchCities = async () => {
      try {
        const apiResponse = await NonAuthAxios({
          url: "/fetch_city_no_token",
          method: "post",
          payload: { city_id: from?.city_id, boarding_point_id: from?.boarding_point_id },

        });

        if (apiResponse.status) {
          setFromTravelCities([apiResponse?.data]);
        } else {
          setFromTravelCities([]);
        }
      } catch (error) {
        setFromTravelCities([]);
      }
    };

    fetchCities();
  }, [fromDetails !== undefined]);


  useEffect(() => {
    const fetchCities = async () => {
      try {
        const apiResponse = await NonAuthAxios({
          url: "/fetch_city_no_token",
          method: "post",
          payload: { city_id: to?.city_id, boarding_point_id: to?.boarding_point_id },
        });


        if (apiResponse.status) {
          setToTravelCities([apiResponse?.data]);
        } else {
          setToTravelCities([]);
        }
      } catch (error) {
        setToTravelCities([]);
      }
    };

    fetchCities();
  }, [toDetails !== undefined]);






  return (
    <form onSubmit={travelFormik.handleSubmit}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <Box sx={{
          flex: 1, minWidth: "180px",
          "@media (max-width:600px)": {
            minWidth: '100%',
          },
        }}>
          <Box component="label" sx={{ display: "block", mb: 1, fontFamily: '"Segoe UI", sans-serif', fontWeight: '600', }}>
            <img src={FromIcon} alt="from" style={styleCss.FromIconalign} /> From
          </Box>
          {/* {JSON.stringify(fromtravelCities)} */}
          <Autocomplete
            options={fromtravelCities}
            value={travelFormik.values.from || null}
            getOptionLabel={(options) => options?.boarding_point_name}
            onChange={(event, newValue) => travelFormik.setFieldValue('from', newValue)}
            onInputChange={(event, newValue, reason) => { if (reason === "input") fromFetchCities(newValue) }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Enter departure city"
                variant="outlined"
                fullWidth
                error={travelFormik.touched.from && Boolean(travelFormik.errors.from)}
                InputLabelProps={{ style: { fontFamily: "Segoe UI" } }}
                size="small"
                sx={styleCss.CommonInputstyle}
              />
            )}
          />
        </Box>
        <IconButton
          onClick={handleSwap}
          sx={{
            backgroundColor: "#ff5714",
            color: "#fff",
            display: 'flex',
            marginTop: '28px',
            "&:hover": {
              backgroundColor: "#e04c10"
            },
            "@media (max-width:600px)": {
              marginTop: '0px',
            },
          }}
        >
          <SwapHorizIcon />
        </IconButton>

        {/* To Field */}
        <Box sx={{
          flex: 1, minWidth: "180px",
          "@media (max-width:600px)": {
            minWidth: '100%',
          },
        }}>
          <Box component="label" sx={{
            display: "block", mb: 1, fontFamily: '"Segoe UI", sans-serif', fontWeight: '600',
            "@media (max-width:600px)": {
              marginTop: '-25px',
            },
          }}>
            <img src={ToIcon} alt="to" style={styleCss.FromIconalign} /> To
          </Box>
          <Autocomplete
            options={totravelCities}
            value={travelFormik.values.to || null}
            getOptionLabel={(options) => options?.boarding_point_name}
            onChange={(event, newValue) => {
              if (travelFormik.values.from === newValue?.boarding_point_name) {
                travelFormik.setFieldValue('to', "")
              } else {
                travelFormik.setFieldValue('to', newValue)
              }
            }}
            onInputChange={(event, newValue, reason) => { if (reason === "input") toFetchCities(newValue) }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={travelFormik.touched.to && Boolean(travelFormik.errors.to)}
                label="Enter destination city"
                variant="outlined"
                fullWidth
                InputLabelProps={{ style: { fontFamily: '"Segoe UI", sans-serif', } }}
                size="small"
                sx={styleCss.CommonInputstyle}
              />
            )}
          />
        </Box>

        {/* Date Field */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{
            flex: 1, minWidth: "180px",
            "@media (max-width:600px)": {
              minWidth: '100%',
            },
          }}>
            <Box
              component="label"
              sx={{ display: "block", mb: 1, fontFamily: '"Segoe UI", sans-serif', fontWeight: 600 }}
            >
              <img src={DateIcon} alt="date" style={{
                verticalAlign: 'middle', width: '18px', marginTop: '-5px',
              }} /> Date
            </Box>
            <DatePicker
              label="Date"
              value={travelFormik.values?.travelDate ? dayjs(travelFormik.values.travelDate) : null}
              onChange={(newValue) =>
                travelFormik.setFieldValue("travelDate", newValue ? dayjs(newValue).toDate() : null)
              }
              // minDate={dayjs()}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  className: "custom-date-picker",
                  InputLabelProps: {
                    style: {
                      fontFamily: '"Segoe UI", sans-serif',
                      color: "#364252",
                    },
                  },
                },
              }}
            />

          </Box>
        </LocalizationProvider>
        <Button
          onClick={handleTodaybutton}
          variant="outlined"
          sx={{
            borderColor: "#fed5c6",
            backgroundColor: "#fed5c6",
            color: "#030213",
            fontFamily: '"Segoe UI", sans-serif',
            fontWeight: 600,
            fontSize: "15px",
            borderRadius: "7px",
            padding: "4px 20px",
            minHeight: "32px",
            // borderRadius: '50px',
            textTransform: 'capitalize',
            marginTop: '31px',
            "&:hover": { borderColor: "#fed5c6", backgroundColor: "#fed5c6" },
            "@media (max-width:600px)": {
              marginTop: '0px',
            },
          }}
        >
          Today
        </Button>

        {/* Filter Button */}
        <Button
          variant="outlined"
          onClick={handleClick}
          sx={{
            borderColor: "#fed5c6",
            backgroundColor: "#fed5c6",
            color: "#030213",
            fontFamily: '"Segoe UI", sans-serif',
            fontWeight: 600,
            fontSize: "15px",
            borderRadius: "7px",
            padding: "4px 20px",
            minHeight: "32px",
            // borderRadius: '50px',
            textTransform: 'capitalize',
            marginTop: '31px',
            "&:hover": {
              borderColor: "#fed5c6",
              backgroundColor: "#fed5c6",
            },
            "@media (max-width:600px)": {
              marginTop: '0px',
            },
          }}
        >
          Tomorrow
        </Button>
        {/* Search Button */}
        <Button type="submit"
          variant="contained"
          startIcon={<SearchIcon />}
          sx={{
            backgroundColor: "#ff5714",
            color: "#fff",
            fontFamily: '"Segoe UI", sans-serif',
            fontWeight: 600,
            fontSize: "15px",
            borderRadius: "7px",
            padding: "7px 20px",
            minHeight: "32px",
            marginTop: '34px',
            textTransform: "capitalize",
            "&:hover": { backgroundColor: "#e04c10" },
            "@media (max-width:600px)": {
              marginTop: '0px',
              width: '100%',
            },
          }}
        >
          Search
        </Button>

      </Box>
    </form>
  );
};

export default BusSearchBox;
